module.exports = __webpack_public_path__ + "static/media/C17.e965a3c3.png";